import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { logout } from "../../redux/slices/authSlice";
import { ProfileGlyph } from "../common/icons";
import theme from "../../theme";
import infoIcon from "../../assets/icons/infoIcon.svg";

import {
  HeaderComponents,
  HeaderContainer,
  HeaderIcons,
  HeaderTitle,
} from "./Headerstyle";

const MenuGlyph = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <line x1="2" y1="4.5" x2="16" y2="4.5" />
      <line x1="2" y1="9" x2="16" y2="9" />
      <line x1="2" y1="13.5" x2="11" y2="13.5" />
    </g>
  </svg>
);

const Header = ({ title, onToggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: null,
      iconHtml: `<img src=${infoIcon} alt="" style="width:50px;">`,
      showCancelButton: true,
      confirmButtonColor: theme.color.brand,
      cancelButtonColor: theme.color.danger,
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        navigate("/login");
      }
    });
  };

  const name = [user.data?.firstName, user.data?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <HeaderContainer>
      <HeaderTitle>
        <button
          type="button"
          className="toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          <MenuGlyph />
        </button>
        <div className="crumb">
          <h2>{title}</h2>
        </div>
      </HeaderTitle>

      <HeaderComponents>
        <HeaderIcons>
          <div className="nav-item">
            <div className="dropBtn">
              <span className="circled">
                <ProfileGlyph />
              </span>
              <span className="who">
                <strong>{name || "Advertiser"}</strong>
                <em>{user.data?.email || ""}</em>
              </span>
            </div>
            <div className="dropdown-content">
              <Link to="/profile">Profile</Link>
              <button type="button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </HeaderIcons>
      </HeaderComponents>
    </HeaderContainer>
  );
};

export default Header;
